import React, { useState } from 'react';
import { XIcon, ArrowRightIcon } from 'lucide-react';
import { Disclosure } from './Disclosure';
import { useIsDesktop } from '../hooks/useIsDesktop';
import { pains } from '../data/offer';
export function PainSection() {
  const isDesktop = useIsDesktop();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="identificado-titulo" className="w-full bg-cream-100" data-id="element-229" data-mp="2yxxogtrwg5ux">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-28" data-id="element-230" data-mp="2l7kigwykj188">
        <div className="max-w-2xl" data-id="element-231" data-mp="2q043ug3hz0nl">
          <h2 id="identificado-titulo" className="font-display text-2xl font-extrabold leading-tight tracking-tight text-forest-900 sm:text-4xl" data-id="element-232" data-mp="2q15ggp05vv7f">
            ¿Te sentís identificado?
          </h2>
          <p className="mt-3 text-[15px] text-forest-800/75 sm:mt-4 sm:text-lg" data-id="element-233" data-mp="229qcyswnf7ul">
            Si alguno de estos problemas te resulta familiar, el MegaPack Hábitos es para vos.
          </p>
        </div>

        {isDesktop ? <dl className="mt-12 lg:mt-16" data-id="element-234" data-mp="3rlzk5jqrwdr1">
            {pains.map(pain => <div key={pain.title} className="grid gap-6 border-t border-cream-300 py-9 lg:grid-cols-[1.1fr_0.9fr] lg:gap-14" data-id="element-235" data-mp="3nlyt8zmhma33">
                <div data-id="element-236" data-mp="gpxo21zmhm6">
                  <dt className="flex gap-4" data-id="element-237" data-mp="g7qwbhp8l00">
                    <XIcon className="mt-1 h-5 w-5 shrink-0 text-clay-500" aria-hidden="true" data-id="element-238" data-mp="hiv2cf23urn" />
                    <span className="font-display text-2xl font-bold leading-snug text-forest-900" data-id="element-239" data-mp="38wswdib4gvyd">
                      {pain.title}
                    </span>
                  </dt>
                  <dd className="mt-4 space-y-3 pl-9 text-[15px] leading-relaxed text-forest-800/80" data-id="element-240" data-mp="3in48hs4ymbgc">
                    {pain.paragraphs.map(paragraph => <p key={paragraph} data-id="element-241" data-mp="2q5i693d80n7j">{paragraph}</p>)}
                  </dd>
                </div>
                <dd className="flex gap-3 self-center rounded-xl bg-cream-50 px-5 py-5 text-[15px] leading-relaxed text-forest-900" data-id="element-242" data-mp="2l5x98yhm2oxg">
                  <ArrowRightIcon className="mt-1 h-4 w-4 shrink-0 text-moss-600" aria-hidden="true" data-id="element-243" data-mp="p3k4g464ew1k" />
                  <span data-id="element-244" data-mp="yuogow4ew2sp">{pain.answer}</span>
                </dd>
              </div>)}
          </dl> : <>
            <p className="mt-6 text-[13px] font-medium text-moss-600" data-id="element-245" data-mp="12xbc170ak5un">
              Tocá el que te pasa y mirá cómo lo resolvemos
            </p>
            <div className="mt-2" data-id="element-246" data-mp="b399oq1owxb4">
              {pains.map((pain, index) => {
            const isOpen = openIndex === index;
            return <Disclosure key={pain.title} id={`pain-panel-${index}`} isOpen={isOpen} onToggle={() => setOpenIndex(isOpen ? null : index)} className="border-t border-cream-300 last:border-b" header={<span className="flex gap-3" data-id="element-248" data-mp="25njh6d68fxq7">
                        <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay-500" aria-hidden="true" data-id="element-249" data-mp="25n1eaxp2el9b" />
                        <span className="font-display text-[15px] font-bold leading-snug text-forest-900" data-id="element-250" data-mp="1vwow3c4q346c">
                          {pain.title}
                        </span>
                      </span>} data-id="element-247" data-mp="f7z5yg09gdwk" data-mpi={index}>
                    <div className="pl-7" data-id="element-251" data-mp="1muywvk4ln0y0">
                      <div className="space-y-2.5 text-sm leading-relaxed text-forest-800/80" data-id="element-252" data-mp="1hx72mjghf2qn">
                        {pain.paragraphs.map(paragraph => <p key={paragraph} data-id="element-253" data-mp="18xk1lyrnzyy4">{paragraph}</p>)}
                      </div>
                      <p className="mt-3 flex gap-2.5 rounded-lg bg-cream-50 px-4 py-3 text-sm leading-relaxed text-forest-900" data-id="element-254" data-mp="37cwtz097lrbo">
                        <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss-600" aria-hidden="true" data-id="element-255" data-mp="33cmjbaah2cqh" />
                        <span data-id="element-256" data-mp="3fe4fulyylpmv">{pain.answer}</span>
                      </p>
                    </div>
                  </Disclosure>;
          })}
            </div>
          </>}

        <div className="mt-10 max-w-3xl border-t-2 border-forest-900 pt-7 sm:mt-14 sm:pt-10" data-id="element-257" data-mp="35ewzdpwxhevj">
          <h3 className="font-display text-xl font-extrabold leading-snug tracking-tight text-forest-900 sm:text-3xl" data-id="element-258" data-mp="2ro09i6udzbs6">
            Si respondiste “sí” a alguna de estas situaciones, es momento de dejar de empezar de
            cero.
          </h3>
          <div className="mt-4 space-y-2.5 text-[15px] leading-relaxed text-forest-800/85 sm:mt-5 sm:space-y-3 sm:text-lg" data-id="element-259" data-mp="2ho142it9k1jj">
            <p data-id="element-260" data-mp="28po0qm7e03x4">No necesitás otra lista de hábitos que vas a mirar durante tres días.</p>
            <p data-id="element-261" data-mp="2doiu2i2zdavh">
              Necesitás un sistema sencillo que te diga qué hacer, cuándo hacerlo y cómo seguir
              cuando aparezcan los días difíciles.
            </p>
            <p className="font-semibold text-forest-900" data-id="element-262" data-mp="1u4tdlaaccaj7">
              Y eso es exactamente lo que vas a encontrar dentro del MegaPack Hábitos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}